
export const price3rub = (val,with_cop) => {
  var r='-';
  if ('number'==typeof(val) && !isNaN(val)) {
    var rub,tkop;
// определяем рубли копейки    
    if (with_cop) {
      var v=val.toFixed(2);
      var parts=v.split('.',2);
      rub=parts[0];
      var kop=parts[1];
      tkop=kop=='00' ? '' : '.'+kop;
    }else{
      tkop='';
      rub=val.toFixed();
    };
// разбиваем рубли по три цифры
    var rr=[];
    var n=rub.length; 
    var ost=n%3;
    var ind=ost==0 ? 3 : ost;
    for( ;ind<=n; ind=ind+3) {
      var chunk=rub.substring(ind-3,ind);
      rr.push ( chunk );
    };
    var rub1=rr.join("\u2009");//Тонкий пробел U+2009 &thinsp;
    r=rub1+tkop;
  };
  return r;
}

export const get_el = (queryXel) => {
    let ret = null
    if (!queryXel) {
        // допустимо
    } else if ("string" === typeof(queryXel)) {// #topPanel topPanel - без разницы
        queryXel = queryXel.replace(/^#/,'')
        ret = document.getElementById( queryXel )
    } else if  (queryXel instanceof Element) {
        ret = queryXel
    } else {// передали хрень
        console.error('get_el error', queryXel)
    }
    return ret
}

export const slow_deep_clone = obj => {
    return JSON.parse(JSON.stringify(obj))
}

